import { OperationEsrrList, OperationEsrrFilter } from '../../../../services/types/Esrr';
import { ApiState, Action } from '../../../../types';
import { callService, serviceReducer } from '../../../../shared/hooks/serviceReducer';

export type OperationEsrrAction =
  | Action<OperationEsrrList, OperationEsrrFilter>
  | { type: 'PAGE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean };

const reducer = (
  state: ApiState<OperationEsrrList, OperationEsrrFilter>,
  action: OperationEsrrAction
): ApiState<OperationEsrrList, OperationEsrrFilter> => {
  switch (action.type) {
    case 'PAGE':
      return callService(state, { ...state.filter, pageNumber: action.value });
    case 'ORDER':
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        sortField: action.column,
        sortDescending: action.descending,
      });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
